// src/app/lib/constants/ads.constants.ts

export const ADS_TABLE_HEADERS = [
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
];

export const ADS_TABLE_SUB_HEADERS = [
  { label: 'TITLE', key: 'title', noTopBorder: true },
  { label: 'IMAGE', key: 'imageUrl', noTopBorder: true },
  { label: 'SCREEN / LINK', key: 'screen', noTopBorder: true },
  { label: 'PLACEMENT', key: 'placement', noTopBorder: true },
  { label: 'PRIORITY', key: 'priority', noTopBorder: true },
  { label: 'VIEWERS', key: 'viewers', noTopBorder: true },
  { label: 'DATE / TIME', key: 'dateTime', noTopBorder: true },
  { label: 'DETAILS', key: 'details', noTopBorder: true },
  { label: 'ACTION', key: 'status', noTopBorder: true }
];

// Screen ads page headers (without STATUS column)
export const ADS_SCREEN_TABLE_HEADERS = [
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 }
];

export const ADS_SCREEN_TABLE_SUB_HEADERS = [
  { label: 'TITLE', key: 'title', noTopBorder: true },
  { label: 'IMAGE', key: 'imageUrl', noTopBorder: true },
  { label: 'SCREEN / LINK', key: 'screen', noTopBorder: true },
  { label: 'PLACEMENT', key: 'placement', noTopBorder: true },
  { label: 'PRIORITY', key: 'priority', noTopBorder: true },
  { label: 'VIEWERS', key: 'viewers', noTopBorder: true },
  { label: 'DATE / TIME', key: 'dateTime', noTopBorder: true },
  { label: 'DETAILS', key: 'details', noTopBorder: true },
  { label: 'ACTION', key: 'status', noTopBorder: true }
];


// ─── Create / Edit Ads modal ─────────────────────────────────────────────────

export type AdType = 'screen' | 'link';

// Backend codes for the `adsType` field
export const AD_TYPE_CODE: Record<AdType, string> = {
  link: '1',
  screen: '2',
};

export interface AdOption {
  label: string;
  value: string;
}

// "Redirect to" options (screen ads)
export const AD_SCREEN_OPTIONS: AdOption[] = [
  { label: 'Cash-in', value: '1' },
  { label: 'Buy Load', value: '7' },
  { label: 'Paybills', value: '8' },
  { label: 'Redeem', value: '10' },
  { label: 'Purchase', value: '11' },
];

export const AD_PLACEMENT_OPTIONS: AdOption[] = [
  { label: 'BASE', value: 'BASE' },
  { label: 'POPUP', value: 'POPUP' },
];

export const AD_DESCRIPTION_MAX_LENGTH = 65;

export const AD_IMAGE_RULES = {
  minWidth: 300,
  maxWidth: 500,
  minHeight: 300,
  maxHeight: 500,
  maxSizeMB: 5,
  accept: 'image/jpeg,image/png',
};

export const AD_IMAGE_MAX_BYTES = AD_IMAGE_RULES.maxSizeMB * 1024 * 1024;
